/**
 * @description Prevents Angular change detection from running for selected Web Component callbacks.
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__Zone_disable_customElements = true;
